module.exports = __webpack_public_path__ + "static/media/cross.6d0e279e.png";